import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import RunLoader from './components/RunLoader';
import utils from './data/utils';
/**
 * @param {import('./types').CommunicationRunProps} props
 */

var Run = function Run(props) {
  var projectName = props.projectName,
      projectId = props.projectId,
      projectUid = props.projectUid,
      token = props.token,
      jobId = props.jobId,
      parameters = props.parameters,
      rest = _objectWithoutProperties(props, ["projectName", "projectId", "projectUid", "token", "jobId", "parameters"]);

  var allowMissingJobId = !jobId && utils.getParameterValue(parameters, 'jobId');
  var runJobId = jobId || utils.getParameterValue(parameters, 'jobId');
  return React.createElement(RunLoader, Object.assign({
    projectUid: projectUid,
    projectName: projectName,
    projectId: projectId,
    jobId: runJobId,
    allowMissingJobId: allowMissingJobId,
    token: token,
    parameters: parameters
  }, rest));
};

Run.defaultProps = {
  variant: 'microservice',
  disableJobSaving: false
};
export default Run;